








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { TaxTreatmentDto } from "@/api/ClientPortalApiClient";
@Component({})
export default class CbxTaxTreatment extends Vue {
  private types: TaxTreatmentDto[] | null = [];
  public selectedType = new TaxTreatmentDto();

  public created() {
    this.getAvailableTypes();
  }

  public typeSelected(type: TaxTreatmentDto) {
    this.$emit("taxTreatmentSelected", type);
  }

  public setSelected(type: TaxTreatmentDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .taxTreatment_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
